const config = {
    serverBaseUrl: import.meta.env.VITE_API_URL,
    companyGameUrl: import.meta.env.VITE_COMPANY_LOGO_URL,
    environmentType: import.meta.env.VITE_ENVIRONMENT,
    aiServerBaseUrl: import.meta.env.VITE_AI_API_URL,
    insightsDataMode: import.meta.env.VITE_INSIGHTS_DATA_MODE
};

const trimTrailingSlash = (value) => (value ? value.replace(/\/$/, '') : value);

config.serverBaseUrl = trimTrailingSlash(config.serverBaseUrl);
config.companyGameUrl = trimTrailingSlash(config.companyGameUrl);
config.aiServerBaseUrl = trimTrailingSlash(config.aiServerBaseUrl);

export { config };